// Mobile app store links (both live).
export const APP_STORE_URL = 'https://apps.apple.com/us/app/canira/id6769555356';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=io.canira.mobile';

// One link for both phones: canira.io/app opens the right store (pages/GetApp.js).
// public/app-qr.svg is a QR code of this address plus ?src=qr (so a scan is
// counted as a scan, utils/appTracking.js), made once and kept in the site, so
// no outside QR service ever sees our users. Change one, remake the other.
export const APP_LINK_URL = 'https://canira.io/app';
export const APP_QR_IMAGE = '/app-qr.svg';

// Canira TV — the live aggregate channel on the Roku Channel Store (watch on the big screen).
export const ROKU_CHANNEL_URL = 'https://channelstore.roku.com/details/19a3a0ae09130b013494d09181556664:fde10bde0b474ea9cd630d0dfc339d8a/canira-tv';

// The Canira Playbook — free PDF handed to workshop registrants (lead magnet).
// Served statically from frontend/public under a clean slug (robust across
// CDNs/proxies). Users still save it as the pretty name via the anchor's
// `download` attribute. The backend confirmation email builds the same path
// against FRONTEND_URL, so keep the two in sync.
export const PLAYBOOK_PDF_URL = '/canira-playbook-lead-magnet.pdf';

// The Canira Playbook audiobook — the "listen" companion to the PDF, offered
// alongside it as part of the lead magnet. Points at our own podcast page
// (in-app route /podcast/:slug) so we keep the listener on Canira rather than
// handing them off to a third-party reader.
export const PLAYBOOK_AUDIOBOOK_URL = '/podcast/the-canira-playbook-build-once-serve-continuously';
